import { useTranslation } from "react-i18next";
import homeBg from "../../assets/images/home.jpeg";

export default function HeroSection() {
  const { t } = useTranslation("global");

  return (
    <section
      id="intro"
      className="relative bg-center bg-cover min-h-screen bg-no-repeat flex items-center"
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>
      <div className="container mx-auto relative z-10 py-12 md:py-20 text-white">
        <div className="max-w-3xl mx-auto text-center pb-10 px-4">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            {t("Intro.text")}
          </h1>
          <h2 className="text-lg md:text-xl lg:text-2xl mb-6">
            {t("Intro2.text")}
          </h2>
          <p className="text-sm md:text-base lg:text-lg pb-12">
            {t("IntroP.text")}
          </p>
        </div>
        <div className="absolute bottom-0 left-1/2 pb-5">
          <button className="iconBtnPlane">
            <img
              className="w-8 h-8 "
              src={
                new URL("../../assets/images/avion-scroll.svg", import.meta.url)
                  .href
              }
              alt="Plane Icon"
            />
          </button>
        </div>
      </div>
    </section>
  );
}
